module.exports = __webpack_public_path__ + "img/case_img.b8f3c137.png";